import React, {useState} from 'react';
import '../../App.css';
import dcs_logo from '../images/dcs_logo.png';
import {
  AppBar,
  Toolbar,
  Typography,
  Button,
  Container,
  IconButton,
  Stack,
  CssBaseline,
} from "@material-ui/core";

import { Box, Hidden } from '@mui/material';
import MenuIcon from '@mui/icons-material/Menu';
import SwipeableDrawer from '@mui/material/SwipeableDrawer';
import Divider from '@mui/material/Divider';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';


const NavbarDefault = (props) => {
  const [open, setOpen] = useState(false);

  const menuStyle = { textDecoration: 'none', color: "black", textAlign: "left" };
  const drawerStyle = { ":hover": {color:"#7B1113"} };

  const mainLinkStyle = { textDecoration: 'none', color: "white" };
  const adminStyle = {":hover": {color:"#16241f"}, color: "white"}
  const mainMenuStyle = { ":hover": {color:"#16241f"} };

  return (
    <AppBar position='static' style={{ background: '#F8F9FA', backgroundColor: "#223730"}}>
      <Container sx={{ p:2 }} maxWidth="xl" className="font-link">
        <Toolbar>
            <IconButton size='small' edge='start' variant="contained" aria-label='logo'>
                <a href="/"><img src={dcs_logo} alt="logo" height="60" width="60"/></a>
            </IconButton>
            
            <Typography 
              variant='h4'
              component='div'
              fontWeight={700}
              fontSize="2.25rem"
              padding={2}
              style={{ color: "white"}} sx={{flexGrow:1}}
            >
              <Box component="div" sx={{ display: { xs: 'none', sm: 'block' } }}>
                <a href="/" style={{color: "white", textDecoration: "none"}}>DCS HELPDESK</a>
              </Box>
            </Typography>
            <Hidden lgDown>
              <Stack direction="row" spacing={3}>
                <Button variant="text"      sx={mainMenuStyle}><a href="/"                       style={mainLinkStyle}>Home</a></Button>
                <Button variant="text"      sx={mainMenuStyle}><a href="/FAQs"                   style={mainLinkStyle}>FAQs</a></Button>
                <Button variant="text"      sx={mainMenuStyle}><a href="https://dcs.upd.edu.ph/" style={mainLinkStyle}>DCS Website</a></Button>
                <Button variant="text"      sx={mainMenuStyle}><a href="/OpenTicket"             style={mainLinkStyle}>Open Ticket</a></Button>
                <Button variant="text"      sx={mainMenuStyle}><a href="/CheckTicket"            style={mainLinkStyle}>Check Ticket</a></Button>
                <Button variant="outlined"  sx={adminStyle}>   <a href="/Dashboard"              style={mainLinkStyle}>Admin</a></Button>
              </Stack >
            </Hidden>
            <Hidden lgUp>
              <IconButton>
                <MenuIcon fontSize='large' sx={{color: '#FFFFFF'}} onClick={() => setOpen(true)}/>
              </IconButton>
            </Hidden>
          <CssBaseline />
        </Toolbar>
      </Container>
      <Hidden lgUp>
        <SwipeableDrawer anchor="right" PaperProps={{ sx:{ width: '30%'} }} open={open} onOpen={() => setOpen(true)} onClose={() => setOpen(false)}>
          <div spacing={2}>
            <IconButton sx={{marginTop:1, marginBottom:1, marginLeft:1}}>
                <ChevronRightIcon onClick={() => setOpen(false)}/>
            </IconButton>
          </div>
          <Divider/>

          <List>
            <ListItem><Button variant="text"     sx={drawerStyle}><a href="/" width={1}                  style={menuStyle}>Home</a></Button></ListItem>
            <ListItem><Button variant="text"     sx={drawerStyle}><a href="/FAQs"                        style={menuStyle}>FAQs</a></Button></ListItem>
            <ListItem><Button variant="text"     sx={drawerStyle}><a href="https://dcs.upd.edu.ph/"      style={menuStyle}>DCS Website</a></Button></ListItem>
            <ListItem><Button variant="text"     sx={drawerStyle}><a href="/OpenTicket"                  style={menuStyle}>Open Ticket</a></Button></ListItem>
            <ListItem><Button variant="text"     sx={drawerStyle}><a href="/CheckTicket"                 style={menuStyle}>Check Ticket</a></Button></ListItem>
            <ListItem><Button variant="outlined" sx={drawerStyle}><a href="/Dashboard" id={"drawer"}     style={menuStyle}>Admin Login</a></Button></ListItem>
          </List>

        </SwipeableDrawer>
      </Hidden>
    </AppBar>
    )
}

export default NavbarDefault;